<template>
	<transition
		name="modalOverlayFade"
		enter-active-class="fadeIn"
		leave-active-class="fadeOut" >

	<div v-if="modalRender" class="modal is-active" :style="modalVisible ? {overflowY: 'auto'} : {}" v-show="localVisible">

		<transition
			name="modalShowHide"
			enter-active-class="zoomIn"
			leave-active-class="zoomOut" >

		<div class="modal-dialog" :class="modalSize" v-show="localVisible">
			<form class="modal-content form-horizontal" :class="modalSize+' '+modalClass" v-on:submit.prevent="confirm" :enctype="formEnctype">
				<div class="modal-header">

					<h5 class="modal-title">{{ title }}</h5>
					<button type="button" class="close" v-on:click="closeModal"><i class="fa fa-times"></i></button>
				</div>
				<div class="modal-body">
					<slot></slot>
				</div>
				<div class="modal-footer">
					<div class="footer-slot"><slot name="footer"></slot></div>

					<button type="button" class="btn btn-light" v-on:click="closeModal">{{ cancelButtonText ? cancelButtonText : 'Cancel'}}</button>
					<button type="submit" 
						class="btn"
						:class="buttonClass ? buttonClass : 'btn-success'"
						:disabled="working"
						v-if="localSubmitVisible"
						v-html="mutatedConfirmButtonText">
					</button>
				</div>
			</form>
		</div>
		</transition>
	</div>
	<div v-else></div>

	</transition>
</template>

<script type="text/javascript">
	export default {
		name: 'ModalDialog',
		props: [
			'modalVisible',
			'modalSize', //modal-lg, modal-sm, modal-full or leave blank for medium
			'title',
			'confirmButtonText',
			'formAction',
			'formEnctype',
			"submitVisible",
			"buttonClass",
			'cancelButtonText',
			"working",
			"modalClass"
		],
		data () {
			return {
				modalRender: false,
				localVisible: this.modalVisible,
				canceled: false,
				confirmed: false,
				randId: Math.floor(Math.random()*100000) //we generate an random number and append it to the hide-overflow class on body so we can ensure that any other modals open don't get scroll removed on body because we close this one
			}
		},
		watch: {
			modalVisible() {
				let vm = this
				if (this.modalVisible) {
					//lock down scrolling
					document.querySelector("body").classList.add("hide-overflow-"+this.randId)

					this.modalRender = true
					this.$nextTick(() => {
						vm.localVisible = vm.modalVisible
					})
				}
				else {
					//unlock scrolling
					document.querySelector("body").classList.remove("hide-overflow-"+this.randId)

					this.deRender()
				}
			}
		},
		computed: {
			mutatedConfirmButtonText() {

				let confirmButtonText = this.confirmButtonText
				if (!this.confirmButtonText)
					confirmButtonText = "Save"

				if (this.working)
					return "<i class='fa fa-spinner fa-spin'></i> "+confirmButtonText
				else
					return confirmButtonText
			},
			localSubmitVisible() {
				if (typeof this.submitVisible == 'undefined')
					return true
				else
					return this.submitVisible
			}
		},
		methods : {
			closeModal () {
				this.$emit("closeModal");
			},
			confirm () {
				this.$emit("confirm")
			},
			deRender() {
				let vm = this

				this.localVisible = false

				setTimeout(() => {
					vm.$nextTick(() => {
						if (!this.modalVisible)
							vm.modalRender = false
					})
					
				},1000)
			}
		},
		created() {
			this.randId = Math.floor(Math.random()*100000) //random id so we don't get collisions when removing scroll on body

			if (this.modalVisible)
				this.modalRender = true

		},
		beforeDestroy() {
			//unlock scrolling
			document.querySelector("body").classList.remove("hide-overflow-"+this.randId)
		}
	}
</script>

<style type="text/css" scoped>
	.modal.is-active {
		background-color: rgba(10,10,10,0.8);
		display: block;
	}

	.modal-content {
		border-radius: 10px;
	}

	.modal-footer {
		position: relative;
	}

	.footer-slot {
		position: absolute;
		top: 16px;
		left: 15px;
	}

	.modal-dialog.modal-full {
		margin:0;
		min-width: 100%;
	}

	.modal-dialog.modal-full .modal-content.modal-full  {
		min-height: 100vh;
	}

	.modal-xl {
		max-width: 990px
	}

	@media (max-width: 992px) {
		.modal-lg {
			width: 100%!important;
			max-width: 800px!important;
		}
	}

	@media (max-width: 575px) {
		.modal-dialog.modal-lg,
		.modal-dialog.modal-xl {
			margin: -1px;
		}

		.modal-dialog.modal-lg .modal-content,
		.modal-dialog.modal-xl .modal-content {
			min-height: 100vh;
		}
	}

	@media (max-width: 360px) {
		.modal-dialog {
			margin: -1px;
		}

		.modal-dialog .modal-content {
			min-height: 100vh;
		}
	}

</style>